module.exports = __webpack_public_path__ + "img/farzana-christopher-129.f97acc18.jpg";